import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import keepAlive from './modules/keepAlive'
// 业务模块 store
import accountInfo from './modules/accountInfo' // 账号资料

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    user,
    keepAlive,
    accountInfo
  },
  getters
})

export default store
